// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__cwCD2","label":"style_label__XsM-3"};